/**
 * Cart Drawer Legacy Logic - Cleaned up version
 * Contains: property translations, progress bar updates, gift logic
 */

// Prevent double initialization
if (window._cartDrawerLegacyInitialized) {
    console.log('⚠️ Cart drawer legacy already initialized, skipping');
} else {
    window._cartDrawerLegacyInitialized = true;

    // Simple debug function (logs to console only, no visual panel)
    function debugLog(message, type = 'log') {
        console.log(`[Cart] ${message}`);
    }

    document.addEventListener("DOMContentLoaded", function () {
        console.log('🛒 Cart drawer legacy starting...');

        // French translations for personalized bracelet properties
        const propertyTranslations = {
            'size': 'Taille',
            'beads-size': 'Taille des perles',
            'bead-size': 'Taille des perles',
            'beads size': 'Taille des perles',
            'bead-1': 'Perle 1',
            'bead-2': 'Perle 2',
            'bead-3': 'Perle 3',
            'bead-4': 'Perle 4',
            'bead-5': 'Perle 5',
            'bead-6': 'Perle 6',
            'bead-7': 'Perle 7',
            'bead-8': 'Perle 8',
            'stone': 'Pierre',
            'stone-1': 'Pierre 1',
            'stone-2': 'Pierre 2',
            'stone-3': 'Pierre 3',
            'color': 'Couleur',
            'colour': 'Couleur',
            'material': 'Matériau',
            'length': 'Longueur',
            'width': 'Largeur',
            'diameter': 'Diamètre',
            'personalization': 'Personnalisation',
            'engraving': 'Gravure',
            'custom': 'Personnalisé',
            'note': 'Note',
            'special-request': 'Demande spéciale',
            'bracelet size': 'Taille du bracelet',
            'wrist size': 'Tour de poignet',
            'gemstone': 'Pierre précieuse',
            'crystal': 'Cristal'
        };

        window.cartPropertyTranslations = propertyTranslations;
        window.translatePropertyKey = function (key) {
            const lowerKey = key.toLowerCase();
            return propertyTranslations[lowerKey] || key;
        };

        // Global gift state - prevents ANY double adds
        if (!window._giftState) {
            window._giftState = {
                isAdding: false,
                isRemoving: false,
                lastAction: 0,
                cooldown: 5000 // 5 seconds cooldown between actions
            };
        }

        // Fetch cart data
        async function fetchCartData() {
            try {
                const response = await fetch('/cart.js');
                if (!response.ok) throw new Error('Cart fetch failed');
                return await response.json();
            } catch (error) {
                console.error("Error fetching cart:", error);
                return null;
            }
        }

        // Update progress bar visuals
        function updateProgressBar(cart) {
            debugLog('📊 updateProgressBar called', 'info');
            const bar = document.querySelector(".cart-progress-bar");
            if (!bar) {
                debugLog('📊 No progress bar found in DOM', 'error');
                console.log('📊 No progress bar found');
                return;
            }
            debugLog('📊 Progress bar found!', 'success');

            const fill = bar.querySelector(".cart-progress-bar__fill");
            const text = bar.querySelector(".cart-progress-bar__text");

            if (!fill) {
                console.log('📊 No fill element found');
                return;
            }

            const cartTotal = cart.total_price / 100;
            const thresholdShipping = parseInt(bar.getAttribute('data-threshold-shipping')) || 60;
            const thresholdGift = parseInt(bar.getAttribute('data-threshold-gift')) || 1;
            const mode = bar.getAttribute('data-progress-mode') || "shipping_and_gift";
            const textBelow = bar.getAttribute('data-text-below') || '';
            const textMid = bar.getAttribute('data-text-mid') || '';
            const textComplete = bar.getAttribute('data-text-complete') || '';

            let progress = 0;
            let displayText = '';

            if (mode === "shipping_only") {
                progress = Math.min((cartTotal / thresholdShipping) * 100, 100);
                displayText = cartTotal >= thresholdShipping ? textComplete :
                    textBelow.replace("[remaining]", Math.ceil(thresholdShipping - cartTotal));
            } else if (mode === "gift_only") {
                progress = Math.min((cartTotal / thresholdGift) * 100, 100);
                displayText = cartTotal >= thresholdGift ? textComplete :
                    textBelow.replace("[remaining]", Math.ceil(thresholdGift - cartTotal));
            } else {
                // shipping_and_gift mode
                if (cartTotal >= thresholdShipping) {
                    progress = 100;
                    displayText = textComplete;
                } else if (cartTotal >= thresholdGift) {
                    const progressInSecondPhase = (cartTotal - thresholdGift) / (thresholdShipping - thresholdGift);
                    progress = 50 + (50 * progressInSecondPhase);
                    displayText = textMid.replace("[remaining]", Math.ceil(thresholdShipping - cartTotal));
                } else {
                    const progressInFirstPhase = cartTotal / thresholdGift;
                    progress = 50 * progressInFirstPhase;
                    displayText = textBelow.replace("[remaining]", Math.ceil(thresholdGift - cartTotal));
                }
            }

            debugLog(`📊 Progress: ${progress.toFixed(1)}% | Cart: ${cartTotal}€`, 'success');
            console.log('📊 Progress:', progress.toFixed(1) + '%', 'Cart:', cartTotal + '€');
            fill.style.width = Math.min(Math.max(progress, 0), 100) + '%';
            if (text && displayText) text.textContent = displayText;

            updateMilestoneStates(cartTotal, thresholdGift, thresholdShipping, mode);
        }

        // Fonction pour mettre à jour les états visuels des milestones
        function updateMilestoneStates(cartTotal, thresholdGift, thresholdShipping, mode) {
            const giftMilestone = document.querySelector('.cart-progress-bar__milestone--gift');
            const shippingMilestone = document.querySelector('.cart-progress-bar__milestone--shipping');

            if (giftMilestone && (mode === 'gift_only' || mode === 'shipping_and_gift')) {
                if (cartTotal >= thresholdGift) {
                    giftMilestone.classList.add('is-achieved');
                    giftMilestone.classList.remove('is-pending');
                } else {
                    giftMilestone.classList.add('is-pending');
                    giftMilestone.classList.remove('is-achieved');
                }
            }

            if (shippingMilestone) {
                if (cartTotal >= thresholdShipping) {
                    shippingMilestone.classList.add('is-achieved');
                    shippingMilestone.classList.remove('is-pending');
                } else {
                    shippingMilestone.classList.add('is-pending');
                    shippingMilestone.classList.remove('is-achieved');
                }
            }
        }

        // Check gift eligibility with strong protection
        async function checkGiftEligibility(cart) {
            debugLog('🎁 checkGiftEligibility called', 'info');
            const state = window._giftState;
            const now = Date.now();

            if (now - state.lastAction < state.cooldown) {
                debugLog('🎁 Still in cooldown, skipping', 'warn');
                console.log('🎁 Still in cooldown, skipping');
                return;
            }

            const cartDrawer = document.querySelector('cart-drawer-component');
            const giftVariantId = cartDrawer ? cartDrawer.getAttribute('data-gift-variant-id') : null;

            if (!giftVariantId) {
                return;
            }

            const bar = document.querySelector(".cart-progress-bar");
            const thresholdGift = bar ? parseInt(bar.getAttribute('data-threshold-gift')) || 1 : 1;
            const mode = bar ? bar.getAttribute('data-progress-mode') : "shipping_and_gift";

            if (mode !== "gift_only" && mode !== "shipping_and_gift") {
                return;
            }

            const giftVariantIdNum = parseInt(giftVariantId);
            const giftInCart = cart.items.find(item => parseInt(item.variant_id) === giftVariantIdNum);
            const nonGiftItems = cart.items.filter(item => parseInt(item.variant_id) !== giftVariantIdNum);
            const nonGiftTotal = nonGiftItems.reduce((total, item) => total + item.final_line_price, 0) / 100;
            const cartTotal = cart.total_price / 100;

            const checkInfo = {
                cartTotal: cartTotal + '€',
                nonGiftTotal: nonGiftTotal + '€',
                threshold: thresholdGift + '€',
                giftInCart: !!giftInCart,
                nonGiftItems: nonGiftItems.length
            };
            debugLog(`🎁 Check: Total=${cartTotal}€ | NonGiftTotal=${nonGiftTotal}€ | Threshold=${thresholdGift}€ | Gift=${!!giftInCart} | Items=${nonGiftItems.length}`, 'info');
            console.log('🎁 Check:', checkInfo);

            // REMOVE gift if below threshold
            if (nonGiftTotal < thresholdGift && giftInCart && !state.isRemoving) {
                state.isRemoving = true;
                state.lastAction = now;
                debugLog('🎁 Removing gift...', 'warn');

                try {
                    await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: giftInCart.id.toString(), quantity: 0 }),
                    });
                    console.log('✅ Gift removed, refreshing UI...');
                    await refreshCartDrawerUI();
                } catch (e) {
                    console.error('❌ Remove failed:', e);
                } finally {
                    state.isRemoving = false;
                }
                return;
            }

            // ADD gift if above threshold and not already there
            if (nonGiftTotal >= thresholdGift && !giftInCart && !state.isAdding && nonGiftItems.length > 0) {
                state.isAdding = true;
                state.lastAction = now;
                debugLog('🎁 Adding gift... (cart above threshold)', 'success');
                console.log('🎁 Adding gift...');

                try {
                    const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            items: [{ id: giftVariantIdNum, quantity: 1 }]
                        }),
                    });

                    if (response.ok) {
                        console.log('✅ Gift added');
                        await refreshCartDrawerUI();
                    } else {
                        console.error('❌ Add failed:', await response.text());
                    }
                } catch (e) {
                    console.error('❌ Add error:', e);
                } finally {
                    state.isAdding = false;
                }
            }
        }

        // Rafraîchir le cart drawer
        async function refreshCartDrawerUI() {
            debugLog('🔄 refreshCartDrawerUI called', 'info');

            try {
                await new Promise(resolve => setTimeout(resolve, 300));

                document.dispatchEvent(new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                        data: {},
                        sourceId: 'cart-drawer-legacy'
                    }
                }));

                debugLog('✅ cart:update dispatched for native refresh', 'success');
            } catch (e) {
                debugLog(`❌ Refresh error: ${e.message}`, 'error');
                console.error('❌ Refresh error:', e);
            }
        }

        // Main update function
        let lastUpdate = 0;
        async function updateCart(force) {
            debugLog('🔄 updateCart called' + (force ? ' (FORCED)' : ''), 'info');
            const now = Date.now();
            if (!force && now - lastUpdate < 2000) {
                debugLog('🔄 Throttled (< 2s since last update)', 'warn');
                return;
            }
            lastUpdate = now;

            debugLog('🔄 Fetching cart data...', 'info');
            const cart = await fetchCartData();
            if (cart) {
                debugLog(`🔄 Cart fetched: ${cart.item_count} items, ${(cart.total_price / 100).toFixed(2)}€`, 'success');
                updateProgressBar(cart);
                await checkGiftEligibility(cart);
            } else {
                debugLog('❌ Failed to fetch cart data', 'error');
            }
        }

        // Expose updateCart globally for debug panel
        window.updateCart = updateCart;

        // Expose refreshCartDrawerUI globally
        window.refreshCartDrawerUI = refreshCartDrawerUI;

        // Initialize
        function init() {
            debugLog('🔄 init() called', 'info');
            const cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer) {
                debugLog('✅ Cart drawer found, initializing...', 'success');
                console.log('🛒 Cart drawer found, initializing');
                updateCart();
            } else {
                debugLog('⏳ Cart drawer not found yet, retrying in 200ms...', 'warn');
                setTimeout(init, 200);
            }
        }

        // Event listeners
        document.addEventListener('cart:update', function (e) {
            debugLog('📢 cart:update event received (native theme)', 'success');
            window._giftState.lastAction = 0;
            setTimeout(() => updateCart(true), 300);
        });

        document.addEventListener('quantity-selector:update', function (e) {
            debugLog('📢 quantity-selector:update event received', 'info');
            window._giftState.lastAction = 0;
            setTimeout(() => updateCart(true), 300);
        });

        document.addEventListener('cart:refresh', function (e) {
            debugLog('📢 cart:refresh event received (custom)', 'info');
            window._giftState.lastAction = 0;
            setTimeout(() => updateCart(true), 300);
        });

        document.addEventListener('cart:change', function (e) {
            debugLog('📢 cart:change event received (custom)', 'info');
            window._giftState.lastAction = 0;
            setTimeout(() => updateCart(true), 300);
        });

        // Listen to cart drawer opening
        const cartDrawerObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                    const dialog = mutation.target;
                    if (dialog.open) {
                        debugLog('🛒 Cart drawer opened (dialog.open = true)', 'success');
                        setTimeout(() => updateCart(), 100);
                    }
                }
            });
        });

        const observeCartDrawer = () => {
            const dialog = document.querySelector('cart-drawer-component dialog');
            if (dialog) {
                debugLog('👁️ Observing cart drawer dialog for open attribute', 'success');
                cartDrawerObserver.observe(dialog, { attributes: true });
            } else {
                setTimeout(observeCartDrawer, 200);
            }
        };
        observeCartDrawer();

        // UNIVERSAL EVENT LISTENER
        const originalAddEventListener = document.addEventListener;
        const cartEvents = new Set();

        document.addEventListener = function (type, listener, options) {
            if (type.toLowerCase().includes('cart') || type.toLowerCase().includes('theme')) {
                if (!cartEvents.has(type)) {
                    cartEvents.add(type);
                    debugLog(`📝 Event listener registered: ${type}`, 'info');
                }
            }
            return originalAddEventListener.call(this, type, listener, options);
        };

        const originalDispatchEvent = document.dispatchEvent;
        document.dispatchEvent = function (event) {
            if (event.type.toLowerCase().includes('cart') || event.type.toLowerCase().includes('theme')) {
                debugLog(`📢 Event dispatched: ${event.type}`, 'warn');
                console.log('Event dispatched:', event.type, event);
            }
            return originalDispatchEvent.call(this, event);
        };

        // Start
        debugLog('🚀 Calling init()...', 'success');
        init();

        // Add keyboard shortcut to toggle debug panel (CTRL+D)
        document.addEventListener('keydown', (e) => {
            if (e.ctrlKey && e.key === 'd') {
                e.preventDefault();
                const panel = document.getElementById('cart-debug-panel');
                if (panel) {
                    panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
                    if (panel.style.display !== 'none') {
                        debugLog('🔍 Debug panel reopened', 'success');
                    }
                }
            }
        });

        // iOS checkout fix
        document.querySelectorAll('.cart-pochettes__checkout-btn, .checkout-btn').forEach(function (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                setTimeout(function () { window.location.href = '/checkout'; }, 100);
            });
            button.style.cursor = 'pointer';
        });
    });
}